import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { NotificationService } from 'src/app/services/notification.service';
import { environment } from 'src/environments/environment';
import { helper } from 'src/environments/helper';
import { OperatoriService } from '../operatori.service';
import { finalize, map } from 'rxjs';

@Component({
    selector: 'app-edit-operatori',
    templateUrl: './edit-operatori.component.html',
    styleUrls: ['./edit-operatori.component.scss']
})
export class EditOperatoriComponent {
    errorTitle: string = environment.config.customNotifications.headers.error;
    errorIcon: string = environment.config.customNotifications.icons.error;
    errorType: string = environment.config.customNotifications.icons.error;
    helper = helper;

    successIcon: string = environment.config.customNotifications.icons.success;

    stateRows: any[] = [];

    selectedProgramIds: number[] = [];
    permisiuniOperator$: any = [];

    token!: string;
    isLoading = false;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: any,
        private dialogRef: MatDialogRef<EditOperatoriComponent>,
        private notificationService: NotificationService,
        private authService: AuthService,
        private operatoriService: OperatoriService,
    ) {
        this.processToken();
        this.loadPermisiuni();
    }
    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    processToken() {
        const tokenObj = this.authService.returnTokenUser();
        tokenObj.then((token) => {
            this.token = token;
            this.operatoriService.setToken(token);
        });
    }

    loadPermisiuni() {
        this.isLoading = true;
        this.operatoriService
            .getPermisiuniList(this.data.id_user)
            .pipe(
                map((results: any) => {
                    this.selectedProgramIds = results.data.operator_allocated.program;

                    return results.data.config.map((item: any) => {
                        item.checked = this.selectedProgramIds.includes(item.id);
                        return item;
                    });
                }),
                finalize(() => {
                    this.isLoading = false;
                })
            )
            .subscribe({
                next: (data) => {
                    this.stateRows = data;
                },
                error: (err) => {
                    console.error('Error loading permissions', err);
                }
            });
    }

    updateCheckedList(item: any, checked: boolean) {
        if (checked) {
            if (!this.selectedProgramIds.includes(item.id)) {
                this.selectedProgramIds.push(item.id);
            }
        } else {
            const index = this.selectedProgramIds.indexOf(item.id);
            if (index > -1) {
                this.selectedProgramIds.splice(index, 1);
            }
        }
    }

    updateOperator() {
        this.isLoading = true;

        this.operatoriService
            .updateOperator(this.data.id_user, { programIds: this.selectedProgramIds })
            .pipe(finalize(() => (this.isLoading = false)))
            .subscribe({
                next: () => {
                    this.dialogRef.close({ success: true });
                },
                error: (err) => {
                    let msg;
                    try {
                        msg = err.error.errors.message[0];
                    } catch {
                        msg = helper.dialogConfig.generalMessages.error;
                    }
                    this.notificationService.warningSwal(
                        helper.dialogConfig.headers.errorAtentie,
                        msg,
                        this.errorIcon
                    );
                }
            });
    }
}
